export const COUNTRIES = [
  { code: 'AUT', label: 'Austria' },
  { code: 'BEL', label: 'Belgium' },
  { code: 'CAN', label: 'Canada' },
  { code: 'CHE', label: 'Switzerland' },
  { code: 'DEU', label: 'Germany' },
  { code: 'DZA', label: 'Algeria' },
  { code: 'ESP', label: 'Spain' },
  { code: 'FRA', label: 'France' },
  { code: 'GBR', label: 'United Kingdom' },
  { code: 'ITA', label: 'Italy' },
  { code: 'LBN', label: 'Lebanon' },
  { code: 'LUX', label: 'Luxembourg' },
  { code: 'MAR', label: 'Morocco' },
  { code: 'NLD', label: 'Netherlands' },
  { code: 'PRT', label: 'Portugal' },
  { code: 'TUN', label: 'Tunisia' },
  { code: 'USA', label: 'United States' },
] as const;

const COUNTRY_CODE_TO_LABEL: ReadonlyMap<string, string> = new Map(COUNTRIES.map((c) => [c.code, c.label]));
const COUNTRY_LABEL_TO_CODE: ReadonlyMap<string, string> = new Map(
  COUNTRIES.map((c) => [c.label.toLowerCase(), c.code]),
);

/** Resolve a country code (e.g. "FRA") to its display name, falling back to the code itself. */
export function formatCountryName(code: string | undefined): string {
  if (!code) return '';
  return COUNTRY_CODE_TO_LABEL.get(code) ?? code;
}

/**
 * Normalize a country value to its ISO-3 code.
 * Accepts either a code ("FRA") or a name ("France") — handles legacy data
 * where country was stored as a name instead of a code.
 */
export function normalizeCountryCode(value: string | undefined): string {
  if (!value) return '';
  // Already a valid code
  if (COUNTRY_CODE_TO_LABEL.has(value)) return value;
  // Try matching by label (case-insensitive)
  return COUNTRY_LABEL_TO_CODE.get(value.toLowerCase()) ?? value;
}
